import React from 'react';
import AuraSuiteBlack from "src/images/AuraBlackIcon.png";
import AuraSuite from "src/images/aura_suite.png";
import { useTranslation } from "react-i18next";
import { ILicensesInfo, SubscriptionType } from 'src/Utils/Hooks/ManageLicenses/useGetLicensesInfo';
import { getLicenseType } from "src/Utils/Hooks/ManageLicenses/LicenseTypeHelper";

interface LicenseTitleProps {
    isSuiteLicense: boolean;
    showPaymentOption: boolean;
    containsSuiteLicense: boolean;
    licensesInfo: ILicensesInfo;
}

const LicenseTitle: React.FC<LicenseTitleProps> = ({isSuiteLicense, showPaymentOption, containsSuiteLicense, licensesInfo}) => {
    const { t } = useTranslation();
    const isSubscriptionCancelled = () => 
            licensesInfo?.clinicPaymentTransactions?.length > 0 &&
            licensesInfo.clinicPaymentTransactions[0].subscriptionType === SubscriptionType.Cancel;
const getNonSuiteLicenseType = () => {
        if (licensesInfo?.clinicUserAndStorageLicenseInfo?.licenseType) {
            return licensesInfo?.clinicUserAndStorageLicenseInfo?.licenseType;
        }
        else if (licensesInfo?.licenceInfo && licensesInfo.licenceInfo?.length > 0 ) {
            return licensesInfo?.licenceInfo[0].licenseType;  
        }
        else if (licensesInfo?.clinicStorageLicense?.licenseType) {
            return licensesInfo?.clinicStorageLicense.licenseType;   
        }
        return '';
    }
    return (
         <> { 
                        isSuiteLicense ?
                            <div className="row mt-3">
                                <div className="col" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        {
                                            showPaymentOption && containsSuiteLicense ?
                                                <img src={AuraSuiteBlack} alt="Aura Suite Black" style={{width: '48px', height: '48px'}}/> :
                                                <img src={AuraSuite} alt="Aura Suite" style={{width: '48px', height: '48px'}}/>
                                        }
                                        {
                                            !containsSuiteLicense ?
                                            <span className="storagePercentage" style={{marginLeft: '15px'}}>{getLicenseType(licensesInfo.clinicUserAndStorageLicenseInfo.licenseType)}</span> :
                                            <span className="storagePercentage" style={{marginLeft: '15px'}}>{t('AuraSoftwareSuite')} {getLicenseType(licensesInfo.clinicUserAndStorageLicenseInfo.licenseType)}</span>
                                        }
                                        {
                                            showPaymentOption && containsSuiteLicense && isSubscriptionCancelled() &&
                                            <span className="cancelled">({t('Cancelled')})</span>
                                        }
                                    </div>
                                </div>
                            </div> 
                        : <> 
                        {licensesInfo && 
                           <span  className="storagePercentage" > {getNonSuiteLicenseType() }</span>
                        }
                         </>
                    }
        </>
    );
};

export default LicenseTitle;